import { Routes } from '@angular/router';
import { ReaderPageComponent } from './reader-page.component';

export const routes: Routes = [
  // with prefix
  { path: ':prefix/:dppId', component: ReaderPageComponent },
  { path: ':prefix/:dppId/child/:childId', component: ReaderPageComponent },

  // without prefix
  { path: ':dppId', component: ReaderPageComponent },
  { path: ':dppId/child/:childId', component: ReaderPageComponent },
];